import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <footer class="footer">
      <div class="container">
        <div class="footer__inner">
          <div>
            <div class="footer__copyright">
              © Copyright 2024. Made by Shubham
            </div>
            <div class="footer__copyright">
              © Copyright 2023. Desined by EliasDevis
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
